import Vue from '@/utils/gloable'
import App from './App.vue'
import router from './router'
import store from './store'
import vant from "vant"
import filters from "@/utils/filters"
import 'vant/lib/index.css';
import "@/assets/css/recess.css"

//处理当前环境
function isMobileH5() {
  const userAgent = navigator.userAgent;
  return /iPhone|iPad|iPod|Android/i.test(userAgent);
}
if (!isMobileH5()) location.href = "https://www.hnsbdf.com/"

//根节点fontsize大小
function setRem() {
  const baseSize = 100;
  const scale = document.documentElement.clientWidth / 750;
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
}
setRem();
window.addEventListener('resize', setRem)

//全局注入
Vue.use(vant)
Vue.mixin(filters)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
